import store from '@/store'

export function _resolvePatientJourneyListColumnOfType_careNavigatorUser(
    column,
    patientJourney,
    row,
    errors,
    isGoddard
) {
    if (isGoddard && row[column.id]) {
        const userData = row[column.id]

        if (userData.titledFullName) {
            column.cellText = userData.titledFullName
        }

        return
    }

    if (row.careNavigatorClinicianId) {
        const user = store.state.user.users[row.careNavigatorClinicianId]

        if (user) {
            column.cellText = user.titledFullName
        }
    }
}
